import type { IconProps } from './base';
import { BaseIcon } from './base';

export function IconFile(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M4 4C4 2.89543 4.89543 2 6 2H14.4142L20 7.58579V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V4ZM13 4H6V20H18V9H14C13.4477 9 13 8.55228 13 8V4Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
